module.exports = "<div class=\"notice -info -push\">\n  <div class=\"wrapper\">\n    <span class=\"title\">\n      <span class=\"icon\"></span>\n      <span>{{ (flashState$ | async).additionalInfos.title | translate }}</span>\n    </span>\n    <button (click)=\"dismiss()\" class=\"close\"></button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/flash/flash-info/flash-info.component.html
// module id = 1198
// module chunks = 0